import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const messageSelector = createFeatureSelector<IState>('message');
export const getMessagesSelector = createSelector(messageSelector, (state: IState) => state); 
export const getMessageSelector = createSelector(messageSelector, (state: IState) => state.selectedItem); 
